const logContainer = document.getElementById('log-container');

export function setLogString(log_str) {
    if (logContainer) {
        // Если в контейнере присутствует начальный текст, удаляем его
        if (logContainer.textContent.includes("Нет запущенных задач...")) {
            logContainer.innerHTML = "";
        }

        // Создаем новый элемент для строки лога
        const logLine = document.createElement("p");
        logLine.textContent = log_str;
        logLine.classList.add("mb-1");

        // Добавляем новую строку в конец
        logContainer.appendChild(logLine);

        // Если количество строк превышает максимальное, удаляем самые старые
        const maxLogLines = 200;
        while (logContainer.childElementCount > maxLogLines) {
        logContainer.removeChild(logContainer.firstElementChild);
        }

        // Прокручиваем лог вниз, чтобы показывать последние сообщения
        logContainer.scrollTop = logContainer.scrollHeight;
    }
}
